(function () {
  const opts = document.querySelectorAll('#bundle .bundle__card');
  const priceNow = document.getElementById('priceNow');
  const priceWas = document.getElementById('priceWas');
  const priceBadge = document.getElementById('priceBadge');
  const stickyNow = document.getElementById('stickyNow');
  const stickyWas = document.getElementById('stickyWas');
  const stickyDisc = document.getElementById('stickyDisc');
  const stickyVariant = document.getElementById('stickyVariant');
  const stickyBtn = document.getElementById('stickyBtn');
  const stickyAtc = document.getElementById('stickyAtc');
  const variantInput = document.getElementById('mq-variant-id');
  const atcBtn = document.getElementById('atcBtn');
  const productForm = document.getElementById('mq-product-form');
  const galleryBadge = document.getElementById('galleryBadge');
  const mqOfferNow = document.getElementById('mqOfferNow');
  const mqOfferWas = document.getElementById('mqOfferWas');
  const mqOfferPerk = document.getElementById('mqOfferPerk');
  const mqOfferProduct = document.getElementById('mqOfferProduct');

  function formatDiscountApplied(disc) {
    if (!disc) return '';
    return disc.replace(/^–\s?/, '−').replace(/ %$/, ' % appliqué');
  }

  function updateStickyVariant(opt) {
    if (!stickyVariant || !opt) return;
    var title = opt.dataset.variantTitle || '';
    var unitNote = opt.dataset.unitNote || '';
    stickyVariant.textContent = unitNote ? title + ' · ' + unitNote : title;
  }

  function updateStickyPricing(opt) {
    if (!opt) return;
    if (stickyNow) stickyNow.textContent = opt.dataset.now || '';
    if (stickyWas) {
      stickyWas.textContent = opt.dataset.was || '';
      stickyWas.hidden = !opt.dataset.was;
    }
    if (stickyDisc) {
      var discText = formatDiscountApplied(opt.dataset.discount || '');
      stickyDisc.textContent = discText;
      stickyDisc.hidden = !discText;
    }
  }

  function applyBundle(opt) {
    if (!opt) return;
    opts.forEach(function (o) {
      o.classList.remove('selected');
    });
    opt.classList.add('selected');
    var input = opt.querySelector('input');
    if (input) input.checked = true;
    if (priceNow) priceNow.textContent = opt.dataset.now || '';
    if (priceWas) priceWas.textContent = opt.dataset.was || opt.dataset.msrp || '';
    if (priceBadge) priceBadge.textContent = opt.dataset.discount || '';
    if (window.mqSyncSelectedPricing) {
      window.mqSyncSelectedPricing(opt);
    } else {
      updateStickyPricing(opt);
      updateStickyVariant(opt);
    }
    if (variantInput && opt.dataset.variantId) {
      variantInput.value = opt.dataset.variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (galleryBadge) {
      galleryBadge.textContent = opt.dataset.discount || '';
      galleryBadge.style.display = opt.dataset.discount ? '' : 'none';
    }
    if (mqOfferNow) mqOfferNow.textContent = opt.dataset.now || '';
    if (mqOfferWas) {
      var wasVal = opt.dataset.was || opt.dataset.msrp || '';
      mqOfferWas.textContent = wasVal;
      mqOfferWas.hidden = !wasVal;
    }
    if (mqOfferPerk) {
      var perk = opt.dataset.offerPerk || '';
      mqOfferPerk.textContent = perk;
      mqOfferPerk.hidden = !perk;
    }
    if (mqOfferProduct && opt.dataset.variantTitle) {
      mqOfferProduct.textContent = opt.dataset.variantTitle;
    }
  }

  opts.forEach(function (opt) {
    opt.addEventListener('click', function () {
      applyBundle(opt);
    });
  });

  var initial = document.querySelector('#bundle .bundle__card.selected') || opts[0];
  if (initial) applyBundle(initial);

  function setBtnLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      if (!btn.dataset.originalLabel) btn.dataset.originalLabel = btn.textContent;
      btn.textContent = 'Ajout…';
      btn.disabled = true;
    } else {
      btn.textContent = btn.dataset.originalLabel || btn.textContent;
      btn.disabled = false;
    }
  }

  function showAtcError(message) {
    var el = document.getElementById('mqAtcError');
    if (!el) return;
    el.textContent = message || 'Impossible d\u2019ajouter au panier. R\u00e9essayez.';
    el.hidden = false;
  }

  function clearAtcError() {
    var el = document.getElementById('mqAtcError');
    if (el) el.hidden = true;
  }

  function addToCart(e) {
    if (e) e.preventDefault();
    if (!variantInput || !variantInput.value) return;
    if (atcBtn && atcBtn.disabled) return;

    clearAtcError();
    var variantId = parseInt(variantInput.value, 10);
    setBtnLoading(atcBtn, true);
    setBtnLoading(stickyBtn, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (body) {
            throw new Error(body.description || body.message || 'Impossible d\u2019ajouter au panier.');
          });
        }
        return res.json();
      })
      .then(function () {
        if (window.mqRefreshCart) window.mqRefreshCart();
        if (window.mqLegereMetaOnAddToCart) {
          try {
            window.mqLegereMetaOnAddToCart();
          } catch (metaErr) {}
        }
        if (window.mqOpenCart) {
          window.mqOpenCart();
        } else {
          throw new Error('Panier indisponible. Rechargez la page.');
        }
      })
      .catch(function (err) {
        showAtcError(err && err.message ? err.message : null);
      })
      .finally(function () {
        setBtnLoading(atcBtn, false);
        setBtnLoading(stickyBtn, false);
      });
  }

  if (atcBtn) atcBtn.addEventListener('click', addToCart);
  if (stickyBtn) stickyBtn.addEventListener('click', addToCart);

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (submitter && (submitter.id === 'atcBtn' || submitter.id === 'stickyBtn')) {
        e.preventDefault();
      }
    });
  }

  document.querySelectorAll('.acc__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var isOpen = item.classList.contains('open');
      item.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  var mainImg = document.getElementById('mqMainImg');
  var thumbs = document.querySelectorAll('.gallery__thumb');
  var galleryDotsWrap = document.getElementById('mqGalleryDots');
  var galleryMain = document.querySelector('.gallery__main');
  var galleryTimer = null;
  var galleryTouchStartX = 0;
  var galleryTouchStartY = 0;

  function activateThumb(index, userTriggered) {
    if (!thumbs.length) return;
    var i = ((index % thumbs.length) + thumbs.length) % thumbs.length;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var thumb = thumbs[i];
    thumb.classList.add('active');
    if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
    if (galleryDotsWrap) {
      galleryDotsWrap.querySelectorAll('button').forEach(function (btn, dotIdx) {
        btn.classList.toggle('is-active', dotIdx === i);
      });
    }
    if (userTriggered) restartGalleryAutoplay();
  }

  function stopGalleryAutoplay() {
    if (galleryTimer) {
      clearInterval(galleryTimer);
      galleryTimer = null;
    }
  }

  function startGalleryAutoplay() {
    if (!thumbs.length || thumbs.length < 2) return;
    stopGalleryAutoplay();
    galleryTimer = setInterval(function () {
      var active = document.querySelector('.gallery__thumb.active');
      var idx = active ? Array.prototype.indexOf.call(thumbs, active) : 0;
      activateThumb(idx + 1, false);
    }, 4000);
  }

  function restartGalleryAutoplay() {
    stopGalleryAutoplay();
    startGalleryAutoplay();
  }

  if (galleryDotsWrap && thumbs.length > 1) {
    galleryDotsWrap.innerHTML = '';
    thumbs.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Photo ' + (i + 1));
      if (i === 0) dot.classList.add('is-active');
      dot.addEventListener('click', function () {
        activateThumb(i, true);
      });
      galleryDotsWrap.appendChild(dot);
    });
  }

  document.querySelectorAll('.gallery__thumb').forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      activateThumb(i, true);
    });
  });

  if (galleryMain && thumbs.length > 1) {
    galleryMain.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      galleryTouchStartX = e.touches[0].clientX;
      galleryTouchStartY = e.touches[0].clientY;
      stopGalleryAutoplay();
    }, { passive: true });

    galleryMain.addEventListener('touchend', function (e) {
      if (!e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - galleryTouchStartX;
      var dy = e.changedTouches[0].clientY - galleryTouchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        var active = document.querySelector('.gallery__thumb.active');
        var idx = active ? Array.prototype.indexOf.call(thumbs, active) : 0;
        activateThumb(dx < 0 ? idx + 1 : idx - 1, true);
      } else {
        restartGalleryAutoplay();
      }
    }, { passive: true });
  }

  var thumbPrev = document.getElementById('mqThumbPrev');
  var thumbNext = document.getElementById('mqThumbNext');
  if (thumbPrev) {
    thumbPrev.addEventListener('click', function () {
      var active = document.querySelector('.gallery__thumb.active');
      var idx = active ? Array.prototype.indexOf.call(thumbs, active) : 0;
      activateThumb(idx - 1, true);
    });
  }
  if (thumbNext) {
    thumbNext.addEventListener('click', function () {
      var active = document.querySelector('.gallery__thumb.active');
      var idx = active ? Array.prototype.indexOf.call(thumbs, active) : 0;
      activateThumb(idx + 1, true);
    });
  }

  startGalleryAutoplay();
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopGalleryAutoplay();
    else startGalleryAutoplay();
  });

  var buyNowBtn = document.getElementById('buyNowBtn');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function () {
      if (!variantInput || !variantInput.value) return;
      window.location.href = '/cart/' + variantInput.value + ':1?checkout';
    });
  }

  if (stickyAtc && atcBtn && 'IntersectionObserver' in window) {
    var atcScrolledPast = false;
    var welcomePopupOpen = false;

    function isWelcomePopupOpen() {
      var popup = document.getElementById('mqWelcomePopup');
      return !!(popup && popup.classList.contains('is-open'));
    }

    function updateStickyAtcVisibility() {
      if (!stickyAtc) return;
      welcomePopupOpen = isWelcomePopupOpen();
      stickyAtc.classList.toggle('is-visible', atcScrolledPast && !welcomePopupOpen);
    }

    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          atcScrolledPast = false;
        } else {
          atcScrolledPast = entry.boundingClientRect.top < 0;
        }
        updateStickyAtcVisibility();
      });
    }, { threshold: 0, rootMargin: '0px' });

    stickyObserver.observe(atcBtn);
    updateStickyAtcVisibility();

    document.addEventListener('mq:welcome-popup-change', function (e) {
      welcomePopupOpen = !!(e.detail && e.detail.open);
      updateStickyAtcVisibility();
    });
  }

  function pad(n) { return String(n).padStart(2, '0'); }
  function tickCountdown() {
    var end = new Date();
    end.setHours(23, 59, 59, 999);
    var diff = Math.max(0, end - Date.now());
    var s = Math.floor(diff / 1000);
    var d = document.getElementById('mqCountD');
    var h = document.getElementById('mqCountH');
    var m = document.getElementById('mqCountM');
    var sec = document.getElementById('mqCountS');
    if (!h) return;
    var hrs = Math.floor(s / 3600);
    var mins = Math.floor((s % 3600) / 60);
    var secs = s % 60;
    if (d) d.textContent = pad(0);
    h.textContent = pad(hrs);
    m.textContent = pad(mins);
    sec.textContent = pad(secs);
  }
  tickCountdown();
  setInterval(tickCountdown, 1000);

  function initHorizontalCarousel(trackId, dotsId, itemSelector) {
    var track = document.getElementById(trackId);
    var dotsWrap = document.getElementById(dotsId);
    if (!track || !dotsWrap) return;
    var items = track.querySelectorAll(itemSelector);
    if (!items.length) return;

    dotsWrap.innerHTML = '';
    items.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      if (i === 0) dot.classList.add('is-active');
      dot.addEventListener('click', function () {
        items[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      dotsWrap.appendChild(dot);
    });

    track.addEventListener('scroll', function () {
      var idx = 0;
      var center = track.scrollLeft + track.clientWidth / 2;
      items.forEach(function (item, i) {
        var mid = item.offsetLeft + item.offsetWidth / 2;
        if (Math.abs(mid - center) < item.offsetWidth / 2) idx = i;
      });
      dotsWrap.querySelectorAll('button').forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === idx);
      });
    }, { passive: true });
  }

  initHorizontalCarousel('featTrack', 'featDots', '.feat--card');
  initHorizontalCarousel('tpTrack', 'tpDots', '.tp-card');

  var tpPrev = document.getElementById('tpPrev');
  var tpNext = document.getElementById('tpNext');
  var tpTrack = document.getElementById('tpTrack');
  if (tpTrack && tpPrev && tpNext) {
    tpPrev.addEventListener('click', function () {
      tpTrack.scrollBy({ left: -tpTrack.clientWidth * 0.85, behavior: 'smooth' });
    });
    tpNext.addEventListener('click', function () {
      tpTrack.scrollBy({ left: tpTrack.clientWidth * 0.85, behavior: 'smooth' });
    });
  }

  document.querySelectorAll('[data-mq-scroll-product]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var el = document.querySelector('.product');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    });
  });

  var backTop = document.getElementById('mqBackTop');
  if (backTop) {
    backTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  var liveViewers = document.getElementById('mqLiveViewers');
  if (liveViewers) {
    var tpl = liveViewers.getAttribute('data-viewers-template') || '';
    var count = 26 + Math.floor(Math.random() * 14);
    var txtEl = liveViewers.querySelector('.live-viewers__txt');
    if (txtEl && tpl) {
      txtEl.textContent = tpl.replace(/\d+/, String(count));
    }
  }

  function restoreDiscountUI() {
    try {
      if (window.localStorage.getItem('mq_discount_active') && window.mqApplyWelcomeDiscount) {
        window.mqApplyWelcomeDiscount();
        return true;
      }
    } catch (_) {}
    return false;
  }

  if (!restoreDiscountUI()) {
    var attempts = 0;
    var discountTimer = window.setInterval(function () {
      attempts += 1;
      if (restoreDiscountUI() || attempts > 40) window.clearInterval(discountTimer);
    }, 100);
  }
})();
